import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PermissoesService } from 'src/services/permissoes.service';

@Component({
    selector: 'app-observacao',
    templateUrl: './observacao.component.html',
    styleUrls: ['./observacao.component.scss'],
    standalone: false
})
export class ObservacaoComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  displayModal: boolean = false
  loading: boolean = false
  data: any[] = []
  dropDownPessoa: any[] = []
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '400px';
  constructor(
    protected _formBuilder: FormBuilder,
    protected permissaoService: PermissoesService,
  ) { }

  ngOnInit(): void {
    this.form = this._formBuilder.group({
      id: [null],
      descricao: [null],
      pessoa_id: [null],
    })
    this.index();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 100);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      // Subtrai apenas altura do caption (~60px) e paginator (~60px), header já está dentro do scrollable
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  index(): void {
    // TODO: Implementar chamada ao serviço para carregar dados
    // this.observacaoService.index().subscribe(json => {
    //   this.data = json;
    //   setTimeout(() => {
    //     this.calculateScrollHeight();
    //   }, 100);
    // });
  }

  openNew(){
    this.form.reset()
    this.displayModal = true
  }

  edit(event){
    // TODO: Implementar edição
  }

  save(){
    // TODO: Implementar salvamento
  }

}
